import React, { useRef } from 'react';
import { useMediaQuery } from 'react-responsive';
import { useTranslation } from 'react-i18next';
import FiltersIcon from '../../assets/icons/FiltersIcon';
import { device } from '../../styles/devices';
import { Container, FiltersCTA, FilterWrapper, SkipToWrapper } from './SkipTo.styles';
import useScrollTracker from '../../hooks/useScrollTracker';

type StickyNavProps = {
  handleOpenFilters: () => void;
  isFiltersOpen: boolean;
  selectedFiltersCount: number;
  // displayFilterCTA: boolean;
  // onFiltersOpen: () => void;
};

const SkipTo: React.FC<StickyNavProps> = ({
  selectedFiltersCount,
  handleOpenFilters,
  isFiltersOpen,
}) => {
  const { t } = useTranslation();
  const isLaptop = useMediaQuery({ query: device.laptop });
  const isTablet = useMediaQuery({ query: device.tablet });
  const isMobile = useMediaQuery({ query: '(max-width: 480px)' });

  const stickyRef = useRef<HTMLDivElement>(null);

  const mobileScrolled = useScrollTracker(340);

  const isSticky = mobileScrolled && isMobile;

  return (
    <SkipToWrapper>
      <Container ref={stickyRef} isStuck={isSticky} isFiltersOpen={isFiltersOpen}>
        {!isLaptop && (
          <FilterWrapper>
            <FiltersCTA data-testid="filters-cta" onClick={handleOpenFilters}>
              <FiltersIcon />
              {isTablet ? t('promo.filters.openFilterCta') : t('promo.filters.openFilterCtaMobile')}
              {!!selectedFiltersCount && ` (${selectedFiltersCount})`}
            </FiltersCTA>
          </FilterWrapper>
        )}
      </Container>
    </SkipToWrapper>
  );
};

export default SkipTo;
